import Container from "../Container";
import PricingCard from "./PricingCard";

export default function PricingCards() {
  return (
    <Container>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 p-8 items-start">
        <PricingCard
          title="Free"
          price={0}
          duration=" / 15 Days free trial"
          features={[
            {
              label: "Features title will go here",
              checked: true,
            },
            {
              label: "Features title will go here",
              checked: true,
            },
            {
              label: "Features title will go here",
              checked: true,
            },
            {
              label: "Features title will go here",
              checked: true,
            },
            {
              label: "Features title will go here",
              checked: false,
            },
          ]}
          buttonPrimary={false}
          borderColor="#6AC9FF"
        />
        <PricingCard
          title="Package 1"
          price={7999}
          duration=" / Yearly"
          features={[
            {
              label: "Features title will go here",
              checked: true,
            },
            {
              label: "Features title will go here",
              checked: true,
            },
            {
              label: "Features title will go here",
              checked: true,
            },
            {
              label: "Features title will go here",
              checked: true,
            },
            {
              label: "Features title will go here",
              checked: false,
            },
          ]}
          buttonPrimary={true}
          borderColor="#FE7235"
          isCustomizable={true}
          employees={15}
        />
        <PricingCard
          title="Package 2"
          price={9999}
          duration=" / Yearly"
          features={[
            {
              label: "Features title will go here",
              checked: true,
            },
            {
              label: "Features title will go here",
              checked: true,
            },
            {
              label: "Features title will go here",
              checked: true,
            },
            {
              label: "Features title will go here",
              checked: true,
            },
            {
              label: "Features title will go here",
              checked: false,
            },
          ]}
          buttonPrimary={true}
          borderColor="#1EDCC5"
          isCustomizable={true}
          employees={100}
        />
      </div>
    </Container>
  );
}
